module.exports = __webpack_public_path__ + "static/media/bg1.28d927b7.jpg";